export { default as SaleCategoryPage } from "./View";
export { default as PageSaleCategory } from "./Page";